import { render, staticRenderFns } from "./RiskList.vue?vue&type=template&id=672a085e&scoped=true&"
import script from "./RiskList.vue?vue&type=script&lang=ts&"
export * from "./RiskList.vue?vue&type=script&lang=ts&"
import style0 from "./RiskList.vue?vue&type=style&index=0&id=672a085e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672a085e",
  null
  
)

export default component.exports